import { Injectable } from '@angular/core';
import { CnpjDataService } from './cnpj-data.service';
import { CnpjModel } from 'src/app/shared/service/cnpj/model/cnpj.model';

@Injectable({
  providedIn: 'root'
})
export class CnpjMockService implements CnpjDataService{

  readonly cepAll = [];

  constructor() {
    this.cepAll.push(this.getCnpjItau());
    this.cepAll.push(this.getCnpjEmpty());
    this.cepAll.push(this.getCnpjFalse());
    this.cepAll.push(this.getCnpjErrorData());
  }

  public getCnpj(cnpjId: string): Promise<CnpjModel> {
    const cnpjFound = this.cepAll.find(r => r.code === cnpjId || r.code === '');
    if (cnpjFound) {
      return Promise.resolve(cnpjFound.data);
    } else {
      return Promise.resolve(null);
    }
  }

  protected getCnpjItau() {
    return {
      code : '60872504000123',
      data: {
        success: true,
        razaoSocial: 'ITAU UNIBANCO HOLDING S.A',
      }
    }
  }

  protected getCnpjEmpty() {
    return {
      code : '61822388000109',
      data: {
        success: true,
        razaoSocial: '',
      }
    }
  }

  protected getCnpjFalse() {
    return {
      code : '12345678912345',
      data: {
        success: false,
        razaoSocial: '',
      }
    }
  }

  protected getCnpjErrorData() {
    return {
      code : '10000000000000',
      errorData: {
        msg: '',
      }
    }
  }
}
